export const FeatureName = 'superCustomerPage';
